module.exports = __webpack_public_path__ + "2e940eec799d6707442d667966ac03e1.glb";